import { axiosPrivate } from '@/shared/api/axios'
import { API } from '@/shared/constants/api'
import type { IProject, IProjectQueryById } from '../models/project'

export interface IProjectLookup {
  _id: string
  id: string
  /**
   * El `prj_` con el que v2 direcciona este proyecto. Viaja al lado del `_id` para que
   * un select pueda quedarse en este lookup y aun así resolver lo elegido a una
   * referencia v2, cruzando por clave primaria del mismo documento. Ver ADR 0027.
   *
   * Opcional porque el schema lo declara así: un registro anterior al backfill no lo
   * tiene, y quien traduce debe FALLAR en vez de mandar `undefined`.
   */
  publicId?: string | null
  code: string
  name: string
  currency: string
  society: string
}

/**
 * Lookups legacy (selects dependientes, filtros, editor de plantillas,
 * impresión). El CRUD admin vive en projects-admin.service.ts (listado
 * paginado + mutaciones zod).
 */
export const projectsService = {
  getActive: async () => (await axiosPrivate.get<IProject[]>(API.projects.active)).data,

  getLookup: async () => (await axiosPrivate.get<IProjectLookup[]>(API.projects.lookup)).data,

  getById: async (id: string) =>
    (await axiosPrivate.get<IProjectQueryById>(API.projects.byId(id))).data
}

// ── Print endpoint (document generation) ──
export const getProjectByIdForPrint = async (id: string) =>
  (await axiosPrivate.get<IProjectQueryById>(API.projects.printById(id))).data

// ── Backward compatibility (used by external consumers) ──
export const getProjectsLookup = projectsService.getLookup
export const getProjectById = projectsService.getById
